// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LUa2","textarea":"styles_textarea__KMPs6"};